// project imports
import NavGroup from './NavGroup'
// material-ui
import { Typography } from '@mui/material'
import menuItem from 'menu-items'
import { useAuth } from 'hooks/useAuth' // Giả định bạn có hook này để lấy isAdmin

const MenuList = () => {
  const { isAdmin } = useAuth()

  const navItems = menuItem.items
    .filter((item) => {
      // Nếu group cần quyền admin và người dùng không phải admin => loại bỏ
      if (item.needAdmin && !isAdmin) return false
      return true
    })
    .map((item) => {
      switch (item.type) {
        case 'group':
          return <NavGroup key={item.id} item={item} />
        default:
          return (
            <Typography key={item.id} variant="h6" color="error" align="center">
              Menu Items Error
            </Typography>
          )
      }
    })

  return <>{navItems}</>
}

export default MenuList
